import React from 'react';
import { goToNextStep, goToPreviousStep } from '@src/stores/newFlowStore';
import { useReturnStore } from '@src/stores/returnStore';
import { ReturnHeaders } from '@src/components/shared/ReturnHeaders';
import { ReturnButtons } from '@src/components/shared/ReturnButtons';
import QuantitySelectionItems from '@src/components/quantity-selection/QuantitySelectionItems';
import {
  checkForQtyReasonErrors,
  emptyQtyReasonErrors,
} from '@src/stores/errors/errorQtyReasonStore';
import {
  TagReturnQuantityReasonSubmission,
  TagOnReturnReasonQuantityErrorMessage,
} from '@src/utils/analytics-tagging';

const QuantitySelectionStep = () => {
  const selectedItems = useReturnStore((state) => state.selectedItems);
  const militaryExchange = useReturnStore((state) => state.militaryExchange);
  const proceedToNextStep = () => {
    const hasErrors = checkForQtyReasonErrors(selectedItems);
    if (hasErrors) {
      TagOnReturnReasonQuantityErrorMessage();
      return;
    }
    TagReturnQuantityReasonSubmission(selectedItems, militaryExchange);
    goToNextStep();
  };

  const proceedBack = () => {
    emptyQtyReasonErrors();
    goToPreviousStep();
  };

  return (
    <div>
      <ReturnHeaders title="Select return quantity and reason" />
      <QuantitySelectionItems />
      <ReturnButtons
        proceedNext={proceedToNextStep}
        proceedBack={proceedBack}
      />
    </div>
  );
};

export default QuantitySelectionStep;
